module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEKADAAQAAAABAAAAEAAAAAA0VXHyAAAAsklEQVQ4Ee1T2w0CIRAEYxnaCvBr7APLUNugEP3k0YpXBzibuJclKrnkPvzxflhmhs3CzWj1+lJKB5ShtbZj7NOqtZ6Ae+fcnfitEAWQJxA3gb2VpZRjrTWA2HdkjLF1wGAjtZuBbhH1b6DU799AGknlnM9L/h2MNMtWX6GbwFp75dawrEUuHO1h8WSMyczBiReuV0/AjRTS+KCgzMCXgjSkZVpewVPKMN4wztBMOOy5wRMo/0AOKG8MiAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/login/icon_login_phone.png
// module id = oMhY
// module chunks = 83